import { Button, Grid } from "@mui/material";
import { DataGrid, GridRowParams } from "@mui/x-data-grid";
import { ApexOptions } from "apexcharts";
import { observer } from "mobx-react-lite";
import ReactApexChart from "react-apexcharts";
import { FireDetectionSectionOneType } from "../../../../../models/detailed-data/fire-detection/FireDetectionSectionOne";
import { MssDatePicker } from "../common/MssDatePicker";
import { TableStyle } from "../GateMoreDetailed/GateSectionOne";
import { columns } from "./FireDetectionConstants";
import CountUp from "react-countup";
import { EMPTY_CHART } from "../DoorMoreDetailed/DoorConsts";
import { CSVLink } from "react-csv";
import { useEffect, useState } from "react";

type Props = {
  sectionOne: FireDetectionSectionOneType;
  sensorId: string;
};
type PieChart = { labels: Array<any>; series: Array<any> };

const FireDetectionSectionOne = observer(({ sectionOne, sensorId }: Props) => {
  const { startDate, setStartDate, summary, tableData, init } = sectionOne;
  const [pieData, setPieData] = useState<PieChart>({ labels: [], series: [1, 1] });

  useEffect(() => {
    let pie: typeof pieData = {
      labels: [],
      series: [],
    };
    summary.data &&
      summary.data.forEach((obj) => {
        pie.labels.push(obj.id);
        pie.series.push(obj.value);
      });

    setPieData(pie);
  }, [summary]);

  const chartOptions: ApexOptions = {
    labels: pieData.labels,
    legend: {
      show: false,
    },
    colors: ["#FF8080", "#80C2FF"],
    plotOptions: {
      pie: {
        dataLabels: {
          offset: -35,
        },
      },
    },
  };
  return (
    <Grid item container>
      <Grid container>
        <Grid item flex={1}>
          <span className="title">전체 응급상황 데이터 (최근 24시간)</span>
        </Grid>
        <Grid item>
          <MssDatePicker
            startDate={startDate}
            setStartDate={(e: string) => {
              setStartDate(e);
              init(sensorId);
            }}
          />
        </Grid>
      </Grid>

      <Grid container sx={{ flex: 1, justifyContent: "space-around", alignItems: "center", marginTop: "50px" }}>
        <Grid
          item
          md={6}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            backgroundColor: "#F7F7FC",
            padding: "45px 30px",
            borderRight: "9px solid #fff",
          }}
        >
          <span style={{ fontSize: "18px" }}>금일 감지 횟수</span>
          <span style={{ fontWeight: "bold", fontSize: "24px" }}>
            <CountUp end={summary.sensorSummary.detected_time} duration={1} /> 회
          </span>
        </Grid>
        <Grid
          item
          md={6}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            backgroundColor: "#F7F7FC",
            padding: "45px 30px",
            borderLeft: "9px solid #fff",
          }}
        >
          <span style={{ fontSize: "18px" }}>최근 감지 시간</span>
          <span style={{ fontWeight: "bold", fontSize: "24px" }}>{summary.sensorSummary.latest_detected_time}</span>
        </Grid>
      </Grid>

      <Grid container marginTop={"40px"}>
        <Grid item md={6}>
          <ReactApexChart options={chartOptions} series={pieData.series} type="pie" height={200} width={"100%"} />
        </Grid>
        <Grid item md={6} sx={{ display: "flex", alignItems: "center" }}>
          <Grid item container alignItems={"center"} justifyContent="center">
            <Grid
              item
              sx={{ backgroundColor: "#F7F7FC", display: "flex", height: "88px", width: "270px", borderRadius: "5px" }}
            >
              <Grid
                item
                md={6}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "space-around",
                  fontWeight: "bold",
                }}
              >
                <span style={{ fontSize: "18px", color: "#80C2FF" }}>정상신호</span>
                <span style={{ fontSize: "20px" }}>
                  <CountUp end={summary.data ? summary.data.find((obj) => obj.id === "정상").value : 0} duration={1} />
                  회
                </span>
              </Grid>

              <Grid
                item
                md={6}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "space-around",
                  fontWeight: "bold",
                }}
              >
                <span style={{ fontSize: "18px", color: "#FF8080" }}>비정상신호</span>
                <span style={{ fontSize: "20px" }}>
                  <CountUp
                    end={summary.data ? summary.data.find((obj) => obj.id === "비정상").value : 0}
                    duration={1}
                  />
                  회
                </span>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid container justifyContent={"flex-end"}>
        <Grid item>
          <CSVLink data={tableData ? tableData : []} filename={`Fire-sensor-data-for-${startDate}`}>
            <Button sx={{ color: "#333", borderRadius: "30px", border: "1px solid #333", minWidth: "125px" }}>
              데이터 추출하기
            </Button>
          </CSVLink>
        </Grid>
      </Grid>

      <Grid container marginTop={"20px"}>
        <Grid item flex={1} height={"300px"}>
          <DataGrid
            rows={tableData ? tableData : []}
            columns={columns}
            //   disableSelectionOnClick
            sx={TableStyle}
            hideFooter
            // onRowClick={(params: GridRowParams) => {
            //   console.log(params);
            // }}
            isRowSelectable={(params: GridRowParams) => {
              return true;
            }}
          />
        </Grid>
      </Grid>
    </Grid>
  );
});

export default FireDetectionSectionOne;
